import ScrollReveal from "components/common/ScrollReveal";

const SectionCard = ({
    head,
    tag,
    body,
    image,
    isImageLeft = true,
    hash,
}) => {
    const textBlock = (
        <ScrollReveal
            variant={isImageLeft ? "left" : "right"}
            className="w-full lg:w-1/2"
        >
            <div className="space-y-4">
                {head && (
                    <h2 className="!text-primary !text-2xl md:!text-3xl !mb-2">
                        {head}
                    </h2>
                )}
                {tag && (
                    <h3 className="!text-xl md:!text-2xl !mb-3">{tag}</h3>
                )}
                <div className="text-secondary/80 leading-relaxed">{body}</div>
            </div>
        </ScrollReveal>
    );

    const imageBlock = (
        <ScrollReveal
            variant={isImageLeft ? "right" : "left"}
            delay={150}
            className="w-full lg:w-1/2"
        >
            <div className="relative">
                <img
                    src={image}
                    alt={head || tag || "Section illustration"}
                    className="w-full h-auto"
                />
            </div>
        </ScrollReveal>
    );

    return (
        <section className="!py-6 md:!py-8">
            <div className="container">
                <div
                    id={hash}
                    className={`flex flex-col lg:flex-row items-center gap-8 lg:gap-10 ${
                        isImageLeft ? "" : "lg:flex-row-reverse"
                    }`}
                >
                    {isImageLeft ? (
                        <>
                            {textBlock}
                            {imageBlock}
                        </>
                    ) : (
                        <>
                            {imageBlock}
                            {textBlock}
                        </>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SectionCard;
